{
  "version": 1,
  "danmaku": [
    { "id": "dm-001", "text": "再来一个，别停啊。", "tags": ["起哄"], "intensity": 2 },
    { "id": "dm-002", "text": "这波稳了，稳住。", "tags": ["加油"], "intensity": 1 },
    { "id": "dm-003", "text": "脸都红了，还嘴硬。", "tags": ["嘲讽"], "intensity": 2 },
    { "id": "dm-004", "text": "气氛都到这儿了，别退。", "tags": ["起哄"], "intensity": 3 },
    { "id": "dm-005", "text": "我押你输，快认了吧。", "tags": ["嘲讽"], "intensity": 2 },
    { "id": "dm-006", "text": "冲啊，全场都看着你。", "tags": ["加油"], "intensity": 2 },
    { "id": "dm-007", "text": "这也太甜了吧。", "tags": ["暧昧"], "intensity": 2 },
    { "id": "dm-008", "text": "主持人自己上啊。", "tags": ["起哄"], "intensity": 2 },
    { "id": "dm-009", "text": "别装，我们都看见了。", "tags": ["起哄"], "intensity": 1 },
    { "id": "dm-010", "text": "快点快点，等不及了。", "tags": ["加油"], "intensity": 1 },
    { "id": "dm-011", "text": "这个眼神有点东西。", "tags": ["暧昧"], "intensity": 2 },
    { "id": "dm-012", "text": "输了不许耍赖哦。", "tags": ["起哄"], "intensity": 1 },
    { "id": "dm-013", "text": "就这？再来三个。", "tags": ["嘲讽"], "intensity": 3 },
    { "id": "dm-014", "text": "全场最勇敢就是你。", "tags": ["加油"], "intensity": 2 },
    { "id": "dm-015", "text": "我心跳都跟着快了。", "tags": ["暧昧"], "intensity": 3 },
    { "id": "dm-016", "text": "离那么近，有意思。", "tags": ["暧昧"], "intensity": 2 },
    { "id": "dm-017", "text": "认罚吧，规矩不能破。", "tags": ["起哄"], "intensity": 2 },
    { "id": "dm-018", "text": "给你三秒，自己选。", "tags": ["起哄"], "intensity": 2 },
    { "id": "dm-019", "text": "甜得我牙都酸了。", "tags": ["暧昧"], "intensity": 2 },
    { "id": "dm-020", "text": "别怂，就一下。", "tags": ["加油"], "intensity": 1 },
    { "id": "dm-021", "text": "这轮我站对面。", "tags": ["围观"], "intensity": 1 },
    { "id": "dm-022", "text": "手别抖，慢慢来。", "tags": ["加油"], "intensity": 1 },
    { "id": "dm-023", "text": "刚刚那一下，绝了。", "tags": ["起哄"], "intensity": 2 },
    { "id": "dm-024", "text": "谁的脸更红啊。", "tags": ["暧昧"], "intensity": 2 },
    { "id": "dm-025", "text": "大家安静，看好戏。", "tags": ["围观"], "intensity": 1 },
    { "id": "dm-026", "text": "你要翻车了兄弟。", "tags": ["嘲讽"], "intensity": 2 },
    { "id": "dm-027", "text": "再靠近一点点。", "tags": ["暧昧"], "intensity": 3 },
    { "id": "dm-028", "text": "这句话我记下了。", "tags": ["围观"], "intensity": 2 },
    { "id": "dm-029", "text": "干得漂亮，继续。", "tags": ["加油"], "intensity": 2 },
    { "id": "dm-030", "text": "全场为你鼓掌。", "tags": ["加油"], "intensity": 1 }
  ]
}
